import {paths} from 'src/routes/paths';

/**
 * All text på landningssidan. Texten beskriver vad Flinky gör och hur man kommer
 * igång — inga slogans, och inga påståenden om funktioner som inte finns.
 */

export const HJÄLTE = {
    rubrik: 'Vad är Flinky?',
    ingress:
        'Svår fråga. Vi gör många saker som innefattar digitaliseraring och automatiseraring av både organisationer och fastigheter. ' +
        'Exakt vad det innebär varierar beroende på om du företräder en organisation, och i så fall vilken typ av organisation det är, ' +
        'eller om du företräder dig själv som privatperson, antinen fastighetsägare eller hyresgäst',
    primär: 'Skapa konto',
    sekundär: 'Se demo'
} as const;

export const DEMO = {
    rubrik: 'Demo',
    ingress: 'En kort film som visar hur bokföring, bokslut, och årsredovisning hänger ihop med underhållsplan, budget, och amoteringar.',


    märkning: 'Filmen är AI-genererad.',
    /** Sätt till true när filmen ligger i public/videos. Fram till dess frågar sidan inte efter den. */
    publicerad: false,
    källa: '/videos/flinky-demo.mp4',
    textning: '/videos/flinky-demo.sv.vtt',
    /** Valfri stillbild. Saknas den visas loggan som titelbild. */
    stillbild: undefined as string | undefined,
    saknas: {
        rubrik: 'Filmen är inte publicerad än',
        text: 'Under tiden finns genomgångar av varje del i presentationerna.',
        länk: 'Till presentationerna'
    }
} as const;

export type Filmkapitel = {
    titel: string;
    /** Sekunder in i filmen. */
    start: number;
};

// TODO: justera starttiderna mot den färdiga filmen.
export const KAPITEL: Filmkapitel[] = [
    {titel: 'Bokföring och bokslut', start: 0},
    {titel: 'Fakturor och dokument', start: 20},
    {titel: 'Bank och betalningar', start: 40},
    {titel: 'Styrelsemöten', start: 60},
    {titel: 'Mitt hem', start: 80}
];

export type Väg = {
    id: string;
    titel: string;
    beskrivning: string;
    steg: string[];
    knapp: { text: string; href: string };
};

export const KOM_IGÅNG = {
    rubrik: 'Kom igång',
    ingress: 'Alla konton skapas på samma sätt. Det som skiljer är vad du gör efter att du har legitimerat dig.',
    vägar: [
        {
            id: 'styrelse',
            titel: 'Styrelseledamot',
            beskrivning: 'Du vill börja använda Flinky i din förening.',
            steg: [
                'Skapa ett konto och legitimera dig med BankID.',
                'Sök upp föreningen med organisationsnumret. Uppgifterna hämtas från Bolagsverket.',
                'Bekräfta ditt styrelseuppdrag och bjud in övriga ledamöter.'
            ],
            knapp: {text: 'Skapa konto', href: paths.REGISTRERA}
        },
        {
            id: 'boende',
            titel: 'Boende',
            beskrivning: 'Din förening använder redan Flinky.',
            steg: [
                'Skapa ett konto och legitimera dig med BankID.',
                'Öppna inbjudan från styrelsen, eller sök upp föreningen och skicka en ansökan.',
                'När styrelsen har godkänt dig ser du din bostad och föreningens information.'
            ],
            knapp: {text: 'Skapa konto', href: paths.REGISTRERA}
        },
        {
            id: 'mitt-hem',
            titel: 'Husägare',
            beskrivning: 'Du bor i villa eller radhus utan förening.',
            steg: [
                'Skapa ett konto.',
                'Lägg in din bostad.',
                'Samla planlösning, dokument och förbrukning av el och värme på ett ställe.'
            ],
            knapp: {text: 'Skapa konto', href: paths.REGISTRERA}
        },
        {
            id: 'utlaningspool',
            titel: 'Utlåningspool',
            beskrivning: 'Föreningen vill låna ut saker till de boende.',
            steg: [
                'Lägg upp föreningens saker och var de förvaras.',
                'De boende bokar och hämtar själva.',
                'Ett utlånat föremål visas med låntagarens adress, aldrig med namnet.'
            ],
            knapp: {text: 'Skapa konto', href: paths.REGISTRERA}
        }
    ] satisfies Väg[]
};

export const SIDFOT = {
    kontakt: 'info@flinky.se'
} as const;
